import { apiRTK, Tag } from 'api/api-rtk'

import type { PersonasResponse } from './model'

export const api = apiRTK.injectEndpoints({
	endpoints: create => ({
		personas: create.query<PersonasResponse, void>({
			providesTags: [Tag.TeamMembers],
			query: () => ({
				url: 'team/personas'
			})
		})
	}),
	overrideExisting: true
})
